import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bike, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const RiderLogin = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!phone.trim()) { toast.error("Enter your phone number"); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/riders/login?phone=${encodeURIComponent(phone.trim())}`);
      if (!res.ok) { toast.error("Phone not found. Contact your manager."); return; }
      const rider = await res.json();
      if (!rider.is_active) { toast.error("Your account is inactive. Contact your manager."); return; }
      localStorage.setItem("pokus_rider", JSON.stringify(rider));
      navigate("/rider/dashboard");
    } catch {
      toast.error("Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0047FF]/10 to-slate-100 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-8">
        {/* Logo */}
        <div className="text-center space-y-3">
          <div className="w-20 h-20 bg-[#0047FF] rounded-3xl flex items-center justify-center mx-auto shadow-xl">
            <Bike className="w-10 h-10 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Pokus Rider</h1>
            <p className="text-sm text-slate-500 mt-1">Sign in to view your tasks</p>
          </div>
        </div>

        {/* Form */}
        <div className="bg-white rounded-3xl p-6 shadow-sm border border-slate-200 space-y-5">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-700">Phone Number</label>
            <Input
              type="tel"
              inputMode="numeric"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              placeholder="e.g. 9876543210"
              className="h-13 text-lg tracking-wider rounded-xl border-slate-300 focus:border-[#0047FF]"
              autoFocus
            />
          </div>
          <Button
            onClick={handleLogin}
            disabled={loading}
            className="w-full h-13 bg-[#0047FF] hover:bg-[#0033CC] text-base font-semibold rounded-xl"
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                Signing in...
              </span>
            ) : (
              <span className="flex items-center gap-2">
                Continue <ArrowRight className="w-5 h-5" />
              </span>
            )}
          </Button>
        </div>

        <p className="text-center text-xs text-slate-400">
          Only registered riders can log in.
        </p>
      </div>
    </div>
  );
};
